import { gzipSync } from 'fflate';
import Tar from 'tar-js';

// TODO: Consider replacing this with a more generic helper
// e.g. a function accepting multiple objects of different types
// or class using builder pattern
// or run the text encoder conditionally based on file ending (e.g. .json, .txt, etc.)
// or expose the text encoder as a parameter
// or take a parameter for the encoding type per file
// or take two parameters: one for files to be encoded and one for files to be copied
export const createTarArchiveOfSingleJsonAndAdditionalFiles = async (
  jsonFilePath: string,
  jsonString: string,
  additionalFiles: { filepath: string; content: string | Uint8Array }[]
): Promise<Uint8Array> => {
  const tar = new Tar();
  // nasty callback api...
  // append to original tar but pass the callback version along as that's the final one
  return new Promise<Uint8Array>((resolve) => {
    tar.append(jsonFilePath, jsonString, (jsonTarBytes) => {
      additionalFiles
        .reduce((promise, file) => {
          return promise.then(
            () =>
              new Promise<Uint8Array>((res) => {
                tar.append(file.filepath, file.content, (newTarBytes) =>
                  res(newTarBytes)
                );
              })
          );
        }, Promise.resolve(jsonTarBytes))
        .then((finalTarBytes) => resolve(finalTarBytes));
    });
  });
};

export const downloadTarGz = (tarBytes: Uint8Array): void => {
  const gzipped = gzipSync(new Uint8Array(tarBytes));
  const blob = new Blob([gzipped], { type: 'application/gzip' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = 'pi-top-usb-setup.tar.gz';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
